// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import RfqQuoteDetailsCustomerProductList from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsCustomerProductList";
import RfqQuoteDetailsSalesRepProductList from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList";
import { LoadingSpinner } from "@insite/mobius/index";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface RfqQuoteDetailsProductListStyles {
    spinnerWrapper?: InjectableCss;
}

export const rfqQuoteDetailsProductListStyles: RfqQuoteDetailsProductListStyles = {};

const styles = rfqQuoteDetailsProductListStyles;

const RfqQuoteDetailsProductList = ({ quoteState }: Props) => {
    const quote = quoteState.value;
    if (!quote) {
        return null;
    }

    // XNG-Changes: adding spinner until products are loaded
    if (quoteState.isLoading) {
        return (
            <StyledWrapper {...styles.spinnerWrapper}>
                <LoadingSpinner />
            </StyledWrapper>
        );
    }

    return quote.isSalesperson ? <RfqQuoteDetailsSalesRepProductList /> : <RfqQuoteDetailsCustomerProductList />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqQuoteDetailsProductList),
    definition: {
        displayName: "Product List",
        allowedContexts: ["RfqQuoteDetailsPage"],
        group: "RFQ Quote Details",
    },
};

export default widgetModule;
